import { type OrderProductVariant } from '../../api/order';

export const getProductSize = (item: OrderProductVariant): string | undefined => {
    const sizeCharacteristic = item.characteristics.find((char) => char.slug.includes('razmer'));

    return sizeCharacteristic ? `${sizeCharacteristic.title}: ${sizeCharacteristic.value}` : undefined;
};
